// 404ページ

import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../constants/routes';
import Button from '../parts/button';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          {/* 404 アイコン */}
          <div className="mx-auto flex items-center justify-center h-24 w-24 bg-red-100 rounded-full mb-6">
            <svg className="h-12 w-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          
          <h2 className="text-6xl font-bold text-gray-900 mb-4">404</h2>
          <h3 className="text-2xl font-semibold text-gray-700 mb-4">
            ページが見つかりません
          </h3>
          <p className="text-gray-600 mb-8 max-w-md mx-auto">
            お探しのページは存在しないか、移動された可能性があります。
            URLをご確認いただくか、ホームページからお探しください。
          </p>
          
          <div className="space-y-4">
            <Link to={ROUTES.HOME}>
              <Button size="lg">
                ホームページに戻る
              </Button>
            </Link>
            
            <div className="text-center">
              <Link 
                to={ROUTES.UPLOAD}
                className="text-primary-600 hover:text-primary-500 text-sm font-medium"
              >
                ファイルアップロードページへ
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;